import { useState } from 'react';
import { FieldErrors, UseFormRegister, UseFormSetValue } from 'react-hook-form';

import { getTemplates } from '@/api/getTemplates';
import Button from '@/components/Button/Button';
import InputText from '@/components/InputText/InputText';
import { SelectTemplateDialog } from '@/components/templates/SelectTemplateDialog';
import TextAreaInput from '@/components/TextArea/TextAreaInput';
import { SupportRecordFormData } from '@/pages/admin/reservations/support-records/[id]';

type Props = {
  register: UseFormRegister<SupportRecordFormData>;
  setValue: UseFormSetValue<SupportRecordFormData>;
  errors: FieldErrors<SupportRecordFormData>;
};

export const VitalForm = ({ register, setValue, errors }: Props) => {
  const [loading, setLoading] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [conditionTemplates, setConditionTemplates] = useState<{ id: number; body: string }[]>([]);

  const handleOpenTemplateDialog = async () => {
    setLoading(true);
    try {
      const { status, result } = await getTemplates();

      if (status === 200 && result.length > 0) {
        const filtered = result.filter((template) => template.category === '体調メモ');
        if (filtered.length === 0) {
          alert('「体調メモ」カテゴリのテンプレートが見つかりませんでした');
          return;
        }
        setConditionTemplates(filtered);
        setIsModalOpen(true);
      } else {
        alert('テンプレートが見つかりませんでした');
      }
    } catch (error) {
      console.error('テンプレートの取得に失敗しました', error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="space-y-4">
      <div className="w-fit">
        <InputText
          label="体温"
          errors={errors.bodyTemperature}
          type="string"
          {...register('bodyTemperature')}
        />
      </div>
      <div className="w-full space-y-2">
        <TextAreaInput
          label="体調メモ"
          errors={errors.condition}
          {...register('condition')}
        />
        <Button
          size="xs"
          variant="outline"
          onClick={handleOpenTemplateDialog}
          disabled={loading}
        >
          {loading ? '読み込み中...' : '定型文から入力'}
        </Button>
      </div>

      {/* テンプレート選択ダイアログ */}
      {isModalOpen && (
        <SelectTemplateDialog
          isOpen={isModalOpen}
          setIsOpen={setIsModalOpen}
          templates={conditionTemplates}
          onSubmit={(selectedTemplate) => {
            setValue('condition', selectedTemplate.body);
          }}
          label={'健康メモ'}
        />
      )}
    </div>
  );
};
